import GenericAjaxService from './GenericAjaxService';
import {privateAPI, publicAPI, adminAPI} from './api';
import moment from 'moment-timezone';

export default class AuthService extends GenericAjaxService {
  static authTokenResponseInterceptor = null;

  static login(
    username, password, verificationToken, verificationCode, locale) {
    return new Promise((resolve, reject) => {
      const timezone = moment.tz.guess();
      const config = {
        headers: {
          'Authorization': 'Basic ' + btoa(username + ':' + password),
        },
      };
      if (locale) {
        config.headers['Accept-Language'] = locale.replace('_', '-');
      }

      let url = `login?zoneId=${timezone}`;
      if (verificationToken) {
        url += `&verificationToken=${verificationToken}&verificationCode=${verificationCode}`;
      }

      privateAPI.get(url, config).then(response => {
        if (response.status === 200) {
          const token = response.headers['rest-auth-token'];
          AuthService.saveAuthToken(token);
          AuthService.addAuthTokenHeader(token);
          AuthService.addAuthTokenResponseInterceptor();
          return response.data;
        }
        reject(response.data);
      }).then(data => {
        resolve(data);
      }).catch(error => {
        const response = error.response;
        if (response) {
          let legacyUserKey = response.headers['legacyuserkey'];
          let data = response.data;
          if (legacyUserKey) {
            reject({
              legacyUserKey: legacyUserKey,
              username: username,
              status: response.status,
            });
          } else if (data) {
            reject(data);
          }
        } else {
          reject(error);
        }
      });
    });
  }

  static logout() {
    return new Promise((resolve, reject) => {
      super.getAPI(privateAPI, 'logout').then(() => {
        AuthService.clearAuthToken();
        AuthService.removeAuthTokenHeader();
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  }

  static requestVerificationCode(username, email, preferredLanguage) {
    return super.postAPI(publicAPI, `verify/requestVerificationCode/login`,
      {
        username: username,
        email: email,
        preferredLanguage: preferredLanguage,
      });
  }

  static requestVerificationCodeForUpdate(username, email, preferredLanguage) {
    return super.postAPI(publicAPI, `verify/requestVerificationCode/migrate`,
      {
        username: username,
        email: email,
        preferredLanguage: preferredLanguage,
      });
  }

  static requestVerificationCodeForRegistration(
    username, email, preferredLanguage, cId, cText, opts) {
    return super.postAPI(publicAPI, `verify/requestVerificationCode/register`,
      {
        username: username,
        email: email,
        preferredLanguage: preferredLanguage,
        cId: cId,
        cText: cText,
      }, opts);
  }

  static requestVerificationCodeForNewEmail(
    username, email, preferredLanguage) {
    return super.postAPI(privateAPI, `verify/requestVerificationCode`,
      {
        username: username,
        email: email,
        preferredLanguage: preferredLanguage,
      });
  }

  static getAuthToken() {
    const token = sessionStorage.getItem('tdsauth');
    if (token && (token !== 'null' && token !== 'undefined')) {
      return token;
    }
    AuthService.clearAuthToken();
    return null;
  }

  static saveAuthToken(token) {
    sessionStorage.setItem('tdsauth', token);
  }

  static clearAuthToken() {
    sessionStorage.removeItem('tdsauth');
  }

  static addAuthTokenHeader(token) {
    if (token != null) {
      privateAPI.defaults.headers.common['rest-auth-token'] = token;
      adminAPI.defaults.headers.common['rest-auth-token'] = token;
      publicAPI.defaults.headers.common['rest-auth-token'] = token;
    }
  }

  static removeAuthTokenHeader() {
    privateAPI.defaults.headers.common['rest-auth-token'] = '';
    adminAPI.defaults.headers.common['rest-auth-token'] = '';
    publicAPI.defaults.headers.common['rest-auth-token'] = '';
  }

  static addAuthTokenResponseInterceptor() {
    AuthService.removeAuthTokenInterceptors();
    AuthService.authTokenResponseInterceptor = super.addResponseErrorInterceptor(
      privateAPI,
      error => {
        if (error.response) {
          if (401 === error.response.status) {
            AuthService.removeAuthTokenHeader();
          }
        }
        return Promise.reject(error);
      });
  };

  static removeAuthTokenInterceptors() {
    if (AuthService.authTokenResponseInterceptor) {
      super.removeResponseInterceptor(privateAPI,
        AuthService.authTokenResponseInterceptor);
      AuthService.authTokenResponseInterceptor = null;
    }
  }

  static handleUnauthorizedErrors(handler) {
    super.addResponseErrorInterceptor(privateAPI, (error) => {
      if (error.response) {
        if (401 === error.response.status) {
          let url = error.response.config.url;
          let baseUrl = url.substring(0, url.indexOf('?'));
          if (!baseUrl.endsWith('login')) {
            handler(error.response);
          }
        }
      }
      return Promise.reject(error);
    });

  }
}